// src/lib/stores/busy.js
import { writable } from 'svelte/store';

export const busy = writable(false);

export const showBusy = () => busy.set(true);
export const hideBusy = () => busy.set(false);
